/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { SessionManager } from './session-manager.service';

@Injectable()
export class NoopSessionManagerService implements SessionManager {
  hasSession(): boolean {
    return true;
  }

  getSession(): string | null {
    return null;
  }
  setSession(value: string, expirationDays?: number): void { }
  clearSession(): void { }
  refreshSession(expirationDays?: number): void { }
}
